<template>

	<div class="load-cart-preset-popup popup_wrap pop_white-s pop_bege">
		<div class="popup_in">
			<div class="popup">
		        <div class="popup_close stay_close close-animate">
					<a href="javascript:void(0);" @click="closePop()">
						<Close />
					</a>
				</div>
				 <div class="corner-top"></div>
				<div class="exists_icon">
					<LOGO />
				</div>
				<div class="pop_frame" v-if="isLoading">
					<div class="text">
						<br>
						אנחנו טוענים את פרטי המתכון שלך...
					</div>
				</div>
				<div class="pop_frame" v-if="!isLoading">
					<h2 class="title25" style="margin-top:20px;">{{cartPreset.popup_title}}</h2>
					<div class="text">{{cartPreset.popup_text}}</div>
					<div class="bt_green ease">
				    	<a href="#" @click.prevent="fillCart">עדכנו את העגלה שלי</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import LOGO from "../../assets/img/carmella.svg";
	import Close from "../../assets/img/close.svg";
	export default {
		data() {
			return {
				isLoading: true,
				cartPresetID: parseInt(this.$route.query['load-cart-preset']),
				cartPreset: {
					popup_title: '',
					popup_text: '',
				}
			}
		},
		methods: {
			closePop() {
        if (typeof ga !== 'undefined') {
          ga.getAll()[0].send({
            hitType: 'event',
            eventCategory: 'Cart',
            eventAction: 'Cart Presets',
            eventLabel: `Close popup [${this.cartPresetID}]`,
            eventValue: 0,
            nonInteraction: true
          });
        }
				this.$modal.hide("load-cart-preset");
			},
			getCartPreset(){
				fetch( wpData.ajax_url + "?action=ccp_getCartById&id=" + this.cartPresetID )
					.then( raw => raw.json() )
						.then( r => {
							this.isLoading = false;
							if ( r.success ) {
								this.cartPreset = r.data;
                if (typeof ga !== 'undefined') {
                  ga.getAll()[0].send({
                    hitType: 'event',
                    eventCategory: 'Cart',
                    eventAction: 'Cart Presets',
                    eventLabel: `View cart preset [${this.cartPresetID}]`,
                    eventValue: 0,
                    nonInteraction: true
                  });
                }
							} else {
                if (typeof ga !== 'undefined') {
                  ga.getAll()[0].send({
                    hitType: 'event',
                    eventCategory: 'Cart',
                    eventAction: 'Cart Presets',
                    eventLabel: `Failed to fetch preset from server [${this.cartPresetID}]`,
                    eventValue: 0,
                    nonInteraction: true
                  });
                  this.$router.push('/');
                }
              }
						})
			},
			fillCart(){
        if (typeof ga !== 'undefined') {
          ga.getAll()[0].send({
            hitType: 'event',
            eventCategory: 'Cart',
            eventAction: 'Cart Presets',
            eventLabel: `Fill cart from preset [${this.cartPresetID}]`,
            eventValue: 0,
            nonInteraction: true
          });
        }
				const mergedProducts = [ ...this.$store.state.added, ...this.cartPreset.cart_items ];
				this.$store.state.added = mergedProducts;
				this.$store.dispatch('sendCartToServer');
				this.closePop();
				setTimeout(()=>{
					window.openCart();
				}, 500);
				
			}
		},
		mounted(){
			this.getCartPreset();
		},
		components: {
			LOGO,
			Close
		}
	}
</script>

<style lang="sass" scoped>
	.load-cart-preset-popup
		display: block

	// .popup
	// 	border-radius: 1rem
	// 	padding: 2rem

</style>